import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const BulkAddMtUsers = async (data) => {
  try {
    return await postData(`/bulk-mt-user/add`, data);
  } catch (error) {
    console.error(error);
  }
};


